import React from "react";
import RegisterComponent from "../components/RegisterComponent";

const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3005';

export default function RegisterPage() {
  const handleRegister = async ({ name, surname, email, password, confirmPassword, invitationCode, networkingCategories }) => {
    //Comprobamos que las contraseñas coincidan
    if (password !== confirmPassword) {
      alert("Las contraseñas no coinciden");
      return false;
    }
    //Preparamos la llamada para el registro
    const body = {
      name: name,
      surname: surname,
      email: email,
      password: password,
      codInvitation: invitationCode,
      networkingCategories: networkingCategories
    };
    console.log("Register Body:", body);

    try {
      const response = await fetch(`${baseUrl}/users/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();
      console.log('Response data:', data);

      if (!response.ok) {
        alert(data.message || 'Error al registrar el usuario');
        return false;
      }

      // Registro exitoso
      alert('Usuario registrado correctamente');
      //Lo enviamos a la página de login
      window.location.href = '/';
      return true;

    } catch (error) {
      console.error('Error en la petición:', error);
      alert('Error de conexión con el servidor');
      return false;
    }
  };

  return React.createElement(RegisterComponent, { registerUser: handleRegister });
}
